export default __webpack_public_path__ + "static/photo-17-6b51d8ad5c937a4d9df83cfd8827b50e.jpg";